import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, setSeo } from "@/lib/api";
import ProductGrid from "@/components/ProductGrid";

export default function NewArrivals() {
  useEffect(() => setSeo("New Arrivals | Latest Modest Fashion | Adam's Boutique", "Discover the latest abayas, hijabs & modest fashion arrivals at Adam's The Islamic Boutique."), []);
  const { data = [], isLoading } = useQuery({ queryKey: ["new-arrivals"], queryFn: async () => (await api.get("/products?flag=new&sort=newest")).data });

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-8 lg:py-12">
      <div className="mb-10 text-center">
        <p className="overline mb-2">Just Landed</p>
        <h1 className="font-serif text-4xl lg:text-6xl text-espresso">New Arrivals</h1>
        <p className="text-espresso/60 mt-4 max-w-xl mx-auto font-sans">The newest additions to our collection — fresh silhouettes, seasonal shades and timeless elegance.</p>
      </div>
      <ProductGrid products={data} loading={isLoading} cols={4} paginate pageSize={12} />
    </div>
  );
}
